module.exports = __webpack_public_path__ + "static/media/h2.35b0ad3f.png";